import { useFeature } from '@/apiHooks/featureSwitches.hook';
import { isFeatureFlagEnabled } from '@/utils/isFeatureFlagEnabled.util';
import { Feature } from '@/@types/featureSwitch';

export const PARAM_KEY_UPSELL = 'upsell';
export const PARAM_KEY_SUCCESS = 's';
export const PARAM_VALUE_UPSELL = 'wohnen-plus-light';

export const useWohnenPlusLightFeature = () => {
  const remote = useFeature(Feature.WOHNEN_PLUS_LIGHT);
  const local = isFeatureFlagEnabled(Feature.WOHNEN_PLUS_LIGHT);
  return remote || local;
};
